import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import classes from './Login.module.css';

import useLineLiff from 'hooks/LineLiff';
import { getLoginUrl } from './LoginAction';

import 'pages/toyotaOfficialAccount/toyota-namespace.css';
import Loading from 'pages/toyotaOfficialAccount/Loading';

const LoginPage = () => {
  const navigate = useNavigate();
  const lineOAName = process.env.REACT_APP_LINE_OA_NAME;
  const [searchParams] = useSearchParams();
  const liffState = searchParams.get('liff.state');
  const directLocations = searchParams.getAll('location');

  const { userInfo, status, setStatus, errorMsg, setErrorMsg } = useLineLiff(
    process.env.REACT_APP_LIFF_ID_LOGIN
  );

  const loginStartedRef = useRef(false);

  useEffect(() => {
    if (!userInfo || loginStartedRef.current) return;
    loginStartedRef.current = true;

    const fetchLoginUrl = async () => {
      try {
        let locations;

        if (liffState) {
          const decodedState = decodeURIComponent(liffState);
          const urlParams = new URLSearchParams(decodedState);
          locations = urlParams.getAll('location');
        } else {
          locations = directLocations;
        }

        setStatus('Validating...');
        const loginUrl = await getLoginUrl(userInfo.userId, locations);
        setStatus('Redirecting...');
        if (loginUrl) {
          window.location.href = loginUrl;
        } else {
          let redirectUrl = searchParams.get('redirectUrl');

          try {
            redirectUrl = atob(redirectUrl);
          } catch (err) {
            console.warn('Error decoding redirectUrl:', err);
          }

          if (redirectUrl) {
            window.location.href = redirectUrl;
          } else if (lineOAName === 'TOYOTA') {
            navigate('/hotai/toyota/binding-fail');
          } else {
            window.location.href = process.env.REACT_APP_LEXUS_LINE_URL;
          }
        }
      } catch (err) {
        if (lineOAName === 'TOYOTA') navigate('/hotai/toyota/binding-fail');
        setErrorMsg(`error occurred while fetching data: ${err.message}`);
      }
    };

    fetchLoginUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  if (lineOAName === 'TOYOTA') {
    return (
      <div className="toyota-webview">
        <Loading />
      </div>
    );
  } else if (errorMsg || status) {
    return <div>{errorMsg ? errorMsg : status}</div>;
  }

  return (
    <div className={classes.container}>
      <h1>Hi!</h1>
      <h2>
        <img
          src={userInfo.pictureUrl}
          alt="profile"
          className={classes.profile__pic}
        />
        {userInfo.displayName}
      </h2>
    </div>
  );
};

export default LoginPage;
